<template>
  <v-container fluid class="down-top-padding">
    <v-row>
      <v-col cols="12">
        <v-toolbar-title>COD Home</v-toolbar-title>
      </v-col>
    </v-row>
    <v-row>
      <!-- <template v-if="loadingData"> -->
      <v-col
        cols="12"
        lg="3"
        md="6"
        v-for="(item, index) in summaries"
        :key="index"
      >
        <card-widget
          :icon="item.icon"
          :label="item.label"
          :value="loadingData ? 0 : item.value"
          type="string"
        ></card-widget>
      </v-col>
      <!-- </template> -->

      <!-- <v-col cols="12" lg="6" md="6">
        <card-widget
          icon="mdi-wallet-outline"
          label="Current Install Balance"
          type="string"
          :value="loadingData ? 0 : installBalance"
        ></card-widget> -->
      <!-- </v-col> -->
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-card>
          <v-toolbar flat>
            <v-col cols="12" class="px-0">
              <div class="d-flex align-center">
                <div class="text-left">
                  <v-toolbar-title class="page-title">
                    List of Dispatch Online Orders (From Day 1 to current)
                  </v-toolbar-title>
                </div>
                <div class="ml-auto">
                  <v-btn
                    color="primary"
                    class="ml-auto"
                    :disabled="exportData.length <= 0"
                  >
                    <download-csv :data="exportData" :name="`${fileName}.csv`">
                      <v-icon dense>mdi-download</v-icon>
                      Export
                    </download-csv>
                  </v-btn>
                </div>
              </div>
            </v-col>
            <v-spacer></v-spacer>
          </v-toolbar>

          <v-divider></v-divider>

          <v-data-table
            :headers="table.headers"
            :items="table.data"
            :items-per-page="10"
            :loading="table.loading"
            item-key="id"
            loading-text="Loading... Please wait"
            class="elevation-1"
          >
            <template
              v-for="header in table.headers.filter((header) =>
                header.hasOwnProperty('formatter')
              )"
              v-slot:[`item.${header.value}`]="{ value }"
            >
              {{ header.formatter(value) }}
            </template>

            <template v-slot:[`item.name`]="{ item }">
              <a href="#" @click.prevent="showDistorbutorCod(item)">{{
                item.name
              }}</a>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <distributor-cod
      ref="distributorCod"
      :key="distributorCodKey"
    ></distributor-cod>
  </v-container>
</template>

<script>
import ShareableMethods from "@/mixins/ShareableMethods";
import CardWidget from "../../components/CardWidget.vue";
import DistributorCod from "../dialogs/acquisition/DistributorCod.vue";
export default {
  mixins: [ShareableMethods],
  name: "HomeDistributor",
  components: { CardWidget, DistributorCod },

  data() {
    return {
      exportData: [],
      fileName: "",

      distributorCodKey: Math.random(),

      loadingData: true,
      installBalance: 0,
      loadBalance: 0,

      summaries: [],

      table: {
        sortDesc: true,
        loading: false,
        headers: [
          {
            text: "Distributor",
            value: "name",
          },
          {
            text: "Pending Confirmation",
            align: "center",
            value: "pendingCount",
          },
          {
            text: "Pending Installation",
            align: "center",
            value: "confirmCount",
          },

          {
            text: "Activated",
            align: "center",
            value: "activatedCount",
          },
          {
            text: "Cancelled",
            align: "center",
            value: "cancelledCount",
          },
        ],
        data: [],
      },
    };
  },

  methods: {
    async getHome() {
      // const { adminLogin } = this.userData;
      await this.$api
        .get(`/online/cod/home`)
        .then((response) => {
          this.loadingData = false;

          const res = response.data;
          const { data } = res;

          for (var key of Object.keys(data)) {
            // console.log(key + " -> " + data[key]);

            if (key != "listOfCodCount") {
              this.summaries.push(data[key]);
            }
          }

          this.table.data = data.listOfCodCount;

          let exportData = data.listOfCodCount.map((item) => {
            return {
              Distributor: item.name,
              "Pending Confirmation": item.pendingCount,
              Confirmed: item.confirmCount,
              Activated: item.activatedCount,
              Cancelled: item.cancelledCount,
            };
          });
          this.fileName = "cod_distributors";
          this.exportData = exportData;

          // const newArr = response.data.data;
          // this.installBalance = newArr[0].installWallet;
          // this.loadBalance = newArr[0].loadWallet;
        })
        .catch((e) => {
          this.loadingData = false;
          console.log(e);
        });
    },

    showDistorbutorCod(item) {
      this.$refs.distributorCod
        .open(item)
        .then(() => {
          this.distributorCodKey = Math.random();
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },

  created() {
    this.getHome();
  },

  computed: {
    userData() {
      return this.$store.getters.userData;
    },
  },
};
</script>
